import { handleActions } from 'redux-actions'
import { GridFilterModel } from '@mui/x-data-grid-pro'
import * as checkInsActions from '../actions'

export interface CheckInsState {
  filterModel: GridFilterModel
}

const initialState: CheckInsState = {
  filterModel: { items: [] },
}

export default handleActions<CheckInsState, GridFilterModel>(
  {
    [checkInsActions.setCheckInsFilterModel.toString()](state, action) {
      return { ...state, filterModel: action.payload }
    },
    [checkInsActions.resetCheckInsFilterModel.toString()]() {
      return { ...initialState }
    },
  },
  initialState
)
